import { HypotheticalWaterfallInput } from "features/financial-reporting/HypotheticalWaterfallInput";
import { HypotheticalWaterfallInputV2 } from "features/financial-reporting/HypotheticalWaterfallInputV2";
import { useEndOfPeriodReportRetrieveSuspense } from "gen/endpoints/end-of-period-report/end-of-period-report";
import { useHypotheticalWaterfallCreateDataRetrieveSuspense } from "gen/endpoints/financial-reporting/financial-reporting";
import { useFeatureFlagActive } from "shared/hooks/useFeatureFlag";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const HypotheticalWaterfallEditPage: React.FC = () => {
  const { fundFamilyId, endOfPeriodReportId } = useRequiredStringParams();

  const { data: hypotheticalWaterfallCreateData } =
    useHypotheticalWaterfallCreateDataRetrieveSuspense(
      fundFamilyId,
      endOfPeriodReportId,
    );

  const { data: endOfPeriodReportData } = useEndOfPeriodReportRetrieveSuspense(
    fundFamilyId,
    endOfPeriodReportId,
  );

  const isHypoWaterfallv2 = useFeatureFlagActive(
    "hypo_waterfalls_with_custom_pnl_input",
  );

  const dateInformation = {
    startDate: endOfPeriodReportData.start_date,
    endDate: endOfPeriodReportData.end_date,
    dateRangeRichValue: endOfPeriodReportData.date_range_rich_value!,
  };

  return isHypoWaterfallv2 ? (
    <HypotheticalWaterfallInputV2
      endOfPeriodReportId={endOfPeriodReportId}
      dateInformation={dateInformation}
    />
  ) : (
    <HypotheticalWaterfallInput
      fundIdToTransactionCodeToAmount={
        hypotheticalWaterfallCreateData.entity_id_to_transaction_code_id_to_amount
      }
      endOfPeriodReportId={endOfPeriodReportId}
      dateInformation={dateInformation}
    />
  );
};
